<template>
    <div class="main-container w-full h-full flex column align-center border-box margin-center p-20">
        
        <div class=" w-full h-full flex column content-item gap-20">
            <AdminTable v-if="loaded"
                :headers="[
                    { key: 'label', name: 'Type' },
                ]"
                :actions="['download']"
                :header="'FIU Templates'"
                :subheader="'Bank Templates'"
                :data="templates.filter(template => BANK_TEMPLATES.includes(template.type))"
                @download="downloadTemplate"
                class="table-main w-full"
            >
            <template #header-parts>
                <div class="logo flex justify-start">
                    <span >
                        <div class="logo-img "><span>KYCWISE</span></div>
                    </span>
                </div>
                
            </template>
            </AdminTable>
            <div v-if="loaded" class="text-left disclaimer">* Note: The prefilled example will not be taken into account when calculating the generated reports.</div>
            
            <AdminTable v-if="loaded"
                :headers="[
                    { key: 'label', name: 'Type' },
                ]"
                :actions="['download']"
                :subheader="'Merchant / PSP Template'"
                :data="templates.filter(template => template.type == 'BANK_MERCHANT_TRANSFER')"
                @download="downloadTemplate"
                class="table-main"
            >
            <template #header-parts>
                <div class="logo flex justify-start">
                    <span >
                        <div class="logo-img "><span>KYCWISE</span></div>
                    </span>
                </div>
                
            </template>
            </AdminTable>
            <div v-if="loaded" class="text-left disclaimer">* Note: The prefilled example will not be taken into account when calculating the generated reports.</div>
            
            <AdminTable v-if="loaded"
                :headers="[
                    { key: 'label', name: 'Type' },
                ]"
                :actions="['download']"
                :subheader="'Player Templates'"
                :data="templates.filter(template => PLAYER_TEMPLATES.includes(template.type))"
                @download="downloadTemplate"
                class="table-main"
            >
            <template #header-parts>
                <div class="logo flex justify-start">
                    <span >
                        <div class="logo-img "><span>KYCWISE</span></div>
                    </span>
                </div>
                
            </template>
            </AdminTable>
            <div v-if="loaded" class="text-left disclaimer">* Note: The prefilled example will not be taken into account when calculating the generated reports.</div>

        </div>
    </div>
</template>

<script setup>
    import API from '@/api/index.js';
    import { ref, onMounted, computed } from 'vue';
    import AdminTable from '@/components/AdminTable.vue';
    import store from '../store/index.js';

    import { BANK_TEMPLATES, PLAYER_TEMPLATES } from '../../../shared/index';
    const templates = ref([]);
    const loaded = ref(false);

    onMounted(async () => {
        try {
            const response = await API.availableTemplates();
            templates.value = response.templates;
            loaded.value = true;
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    });

    async function downloadTemplate(data){
        const response = await API.downloadTemplate(data.type, data.filename);
    }


</script>


<style scoped lang="scss">
    .disclaimer {
        max-width: 1350px;
        margin: auto;
        margin-top: -20px;
        font-size: 11px;
        padding-left: 15px;
        width: 100%;
    }
    .table-header {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
        text-align: left;
    }
    .filename {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .message-attachments {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
.size-of-the-file {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
.name-of-the-file {
    display: flex;
    align-items: center;
    color: black;
    font-size: 0.9rem;

    text-align: left;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
}
.fileicon {
    width: 40px;
    height: 40px;
}
.section {
    margin: auto;
}

.attachment {
    border-radius: .5rem;
    border-width: 1px;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    grid-template-columns: fit-content(100%) 1fr;
    border-color: rgb(224 226 236);
    background-color: rgb(255 255 255);
    padding: .8rem;


    display: flex;
    align-items: center;
}
.table-main {
    margin: auto;

}

</style>